import Hero from "./components/Hero";
import heroBg from "../assets/images/Header.jpg";
import Accordion from "./components/Accordion";
import PrimaryButton from "./components/buttons/PrimaryButton";
import SecondaryButton from "./components/buttons/SecondaryButton";
import Footer from "./components/Footer";
import ContactUsPage from "./components/ContactUs";
import "../css/pages/HomePage.css";
import { ReactComponent as CheckbnoxIcons } from "../assets/icons/Checkbox.svg";
import { ReactComponent as ShieldIcon } from "../assets/icons/Shield.svg";
import { ReactComponent as StarIcon } from "../assets/icons/Star.svg";
import { ReactComponent as TimeIcon } from "../assets/icons/Time.svg";
import RowFlex from "./components/RowFlex";
import StatsRow from "./components/StatsRow";
import FounderSection from "./components/FounderSection";
import Brouchure from "../assets/images/Brochure.png";
import Services from "./components/Services";

const items = [
  { icon: <StarIcon />, label: "FCA REGULATED" },
  { icon: <StarIcon />, label: "VETERAN-FOUNDED" },
  { icon: <CheckbnoxIcons />, label: "PERSONALISED TO YOU" },
  { icon: <TimeIcon />, label: "ADAPTS TO YOUR CAREER" },
  { icon: <ShieldIcon />, label: "ARMED FORCES ONLY" },
];

const HomePage = () => {
  return (
    <div>
      <Hero backgroundImage={heroBg}>
        <div className="nav-regular primary" style={{ whiteSpace: "wrap" }}>
          every rank - Every service - Every stage
        </div>
        <div>
          <h1>
            The Financial Plan
            <br />which survives contact
          </h1>
          <h1 className="primary">with the enemy</h1>
        </div>
        <div className="content" style={{ maxWidth: "600px" }}>
          Your career demands total commitment.{" "}
          <strong>Your financial future deserves the same.</strong> The Plan UK
          was built by a veteran, for the armed forces — covering every stage of
          service and beyond.
        </div>
        <div className="buttons-row-group">
          <div className="buttons-row">
            <a href="/#the-plan">
              <PrimaryButton text="See the plan" />
            </a>
            <a href="/#who-we-cover">
              <SecondaryButton text="Who we cover" />
            </a>
          </div>
          <a href="/#contact">
            <SecondaryButton text="Create your plan" />
          </a>
        </div>
      </Hero>
      <div className="black-container">
        <div className="black-container-content">
          <div className="row-grid-container">
            {items.map((item, idx) => (
              <div className="row-grid-item" key={idx}>
                <span className="row-grid-icon">{item.icon}</span>
                <span className="nav-regular">{item.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="background-image-container">
        <div className="black-container-content">
          <RowFlex
            left={
              <>
                <div className="nav-regular primary">
                  The mission
                  <div className="no-gap">
                    <h1>
                      SOVEREIGN.
                      <br /> SECURE.
                    </h1>
                    <h1 className="primary">READY.</h1>
                  </div>
                </div>
              </>
            }
            right={
              <>
                <div className="content">
                  What kind of person do you want to be — now, and long after
                  you've taken off the uniform?
                </div>
                <div className="content">
                  The one who built wealth from nothing, starting with £50 a
                  month and a decision to begin. The one whose family is
                  protected. The one who left on their own terms —{" "}
                  <strong style={{ color: "var(--primaryColor)" }}>
                    sovereign, secure, and ready for whatever comes next.
                  </strong>
                </div>
                <div className="content">
                  We'll give you the skills, the knowledge, and the plan to
                  build something special. Something meaningful. Something
                  that's entirely yours.
                </div>
              </>
            }
          />
        </div>
      </div>
      <StatsRow />
      <div className="background-image-container ">
        <div className="black-container-content">
          <RowFlex
            left={
              <>
                <div className="nav-regular primary">
                  <div className="no-gap">
                    <h1>FIVE AREAS.</h1>
                    <h1 className="primary">ONE PLAN.</h1>
                    <h1>YOURS.</h1>
                  </div>
                </div>
              </>
            }
            right={
              <>
                <div className="content">
                  Not products. Not policies. <strong>Five commitments</strong>{" "}
                  — built around the life you're building, the family you're
                  protecting, and the future that's entirely yours to design.
                  Every rank. Every stage. Every ambition.
                </div>
              </>
            }
          />
        </div>
      </div>
      <Services />
      <div className="background-image-container plan">
        <div className="black-container-content">
          <RowFlex
            right={
              <>
                {/* <div className="nav-regular primary">
                  <div className="no-gap">
                    <h1>FIVE AREAS.</h1>
                    <h1 className="primary">ONE PLAN.</h1>
                    <h1>YOURS.</h1>
                  </div>
                </div> */}
              </>
            }
            left={
              <>
                <div>
                  <h2>
                    "I don't want to sell you something. I want to make sure{" "}
                    <span style={{ color: "var(--primaryColor)" }}>
                      you have a plan
                    </span>{" "}
                    — because I've seen what happens when you don't."
                  </h2>
                </div>
                <div
                  className="nav-regular"
                  style={{ whiteSpace: "break-spaces" }}
                >
                  Matthew edwards - founder - the plan uk
                </div>
              </>
            }
          />
        </div>
      </div>
      <div className="background-image-container BG2" id="the-plan">
        <div className="black-container-content">
          <div className="contact-us-row">
            <div className="contact-us-info">
              <div className="no-gap">
                <h1>not a brochure.</h1>
                <h1 className="primary">A plan.</h1>
              </div>
              <div className="content">
                The Plan is delivered as a{" "}
                <strong>clear, personal booklet</strong> — not pages of small
                print you'll never read. It maps out exactly where you stand,
                what's covered, and what to do when life changes.
              </div>
              <div className="row-grid-item flex-start">
                <span className="row-grid-icon">
                  <CheckbnoxIcons />
                </span>
                <div className="no-gap">
                  <span className="content">
                    <strong>Ordered and easy to read</strong>
                  </span>
                  <span className="content">
                    Plain language. No jargon. Structured like a mission brief —
                    clear, purposeful, nothing wasted.
                  </span>
                </div>
              </div>
              <div className="row-grid-item flex-start">
                <span className="row-grid-icon">
                  <CheckbnoxIcons />
                </span>
                <div className="no-gap">
                  <span className="content">
                    <strong>Adapts as your career progresses</strong>
                  </span>
                  <span className="content">
                    Promoted? Posted? Life changed? The Plan adjusts. A living
                    document, not a static product.
                  </span>
                </div>
              </div>
              <div className="row-grid-item flex-start">
                <span className="row-grid-icon">
                  <CheckbnoxIcons />
                </span>
                <div className="no-gap">
                  <span className="content">
                    <strong>Removes confusion at moments of crisis</strong>
                  </span>
                  <span className="content">
                    When things go wrong, you don't have time to read the fine
                    print. The Plan tells you exactly what to do, step by step.
                  </span>
                </div>
              </div>
            </div>
            <img src={Brouchure} className="brouchure-image" />
          </div>
        </div>
      </div>
      <div className="background-image-container BG4">
        <div className="black-container-content">
          <RowFlex
            left={
              <>
                {/* <div className="nav-regular primary">
                  <div className="no-gap">
                    <h1>FIVE AREAS.</h1>
                    <h1 className="primary">ONE PLAN.</h1>
                    <h1>YOURS.</h1>
                  </div>
                </div> */}
              </>
            }
            right={
              <>
                <div>
                  <h1>Don't rely on others. Rely on yourself. </h1>
                  <h1 className="primary">Have a plan.</h1>
                </div>
                <div
                  className="nav-regular primary"
                  style={{ whiteSpace: "break-spaces" }}
                >
                  The Plan UK — Financial Resilience for the Armed Forces
                </div>
              </>
            }
          />
        </div>
      </div>
      <FounderSection />
    </div>
  );
};

export default HomePage;
